import { boxStyle } from 'lib/styles/index';
import palette from 'lib/styles/palette';
import styled, { css } from 'styled-components';
import { useNavigate } from 'react-router-dom';

const SpaceBoxRow = ({ controller }) => {
  const { name, isAutoMode, mode, power, temp } = controller;

  return (
    <SpaceBoxRowBlock>
      <div className="space-box-row-left">
        <div className="ellipsis space-box-row-left-name">{name}</div>
        {isAutoMode && power ? (
          <div className="orange-dot" />
        ) : power === 1 && mode === 'C' ? (
          <div className="cold-dot" />
        ) : power === 1 && mode === 'H' ? (
          <div className="red-dot" />
        ) : power === 1 && mode === 'W' ? (
          <div className="green-dot" />
        ) : null}
      </div>
      <div className="space-box-row-right">
        {isAutoMode && power ? (
          <TempMark auto>auto</TempMark>
        ) : isAutoMode && !power ? (
          <TempMark gray>auto</TempMark>
        ) : mode === 'H' && power ? (
          <TempMark heat>{`${temp}˚C`}</TempMark>
        ) : mode === 'C' && power ? (
          <TempMark cold>{`${temp}˚C`}</TempMark>
        ) : mode === 'W' && power ? (
          <TempMark wind>송풍</TempMark>
        ) : (
          'OFF'
        )}
      </div>
    </SpaceBoxRowBlock>
  );
};

const SpaceBoxRowBlock = styled.div`
  margin-bottom: 0.3rem;
  display: flex;
  justify-content: space-between;

  .space-box-row-left {
    width: 70%;
    display: flex;
    align-items: center;
  }

  .space-box-row-left-name {
    font-size: 14px;
    font-weight: 500;
  }

  .red-dot {
    min-width: 8px;
    height: 8px;
    margin-left: 8px;
    border-radius: 50%;
    background: red;
  }

  .orange-dot {
    min-width: 8px;
    height: 8px;
    margin-left: 8px;
    border-radius: 50%;
    background: orange;
  }

  .green-dot {
    min-width: 8px;
    height: 8px;
    margin-left: 8px;
    border-radius: 50%;
    background: green;
  }

  .cold-dot {
    min-width: 8px;
    height: 8px;
    margin-left: 8px;
    border-radius: 50%;
    background: ${palette.theme[1]};
  }

  .space-box-row-right {
    display: flex;
    align-items: center;
    font-size: 10px;
  }
`;

const TempMark = styled.div`
  padding: 2px 6px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${props => (props.heat ? 'red' : `${palette.theme[1]}`)};
  color: ${props => (props.heat ? '#fff' : `${palette.theme[3]}`)};

  ${props =>
    props.wind &&
    css`
      background: green;
      color: #fff;
    `}

  ${props =>
    props.auto &&
    css`
      background: orange;
      color: #fff;
    `}

  ${props =>
    props.gray &&
    css`
      background: #c6c6c6;
      color: #fff;
    `}
`;

const SpaceBox = ({ space }) => {
  const navigate = useNavigate();
  const { id, avgih, avgit, name, spaceOperate, controllerList } = space;

  return (
    <SpaceBoxBlock
      isOperation={spaceOperate}
      onClick={() => navigate(`/service/${id}`)}
    >
      <div className="space-box-header">
        <div className="space-box-header-left">
          <span>{name}</span>
        </div>
        <div className="space-box-header-right">
          <span>{!avgit ? `- ˚C` : `${avgit}˚C`}</span>
          <span>{!avgih ? `- %` : `${avgih}%`}</span>
        </div>
      </div>
      {controllerList.map(controller => (
        <SpaceBoxRow key={controller.id} controller={controller} />
      ))}
    </SpaceBoxBlock>
  );
};

export default SpaceBox;

const SpaceBoxBlock = styled.div`
  ${boxStyle}
  width: 220px;
  height: 200px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  cursor: pointer;

  ${props =>
    props.isOperation &&
    css`
      background: ${palette.theme[3]};
      color: ${palette.theme[0]};
    `}

  .space-box-header {
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
  }

  .space-box-header-left {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .space-box-header-right {
    font-size: 12px;
    span + span {
      margin-left: 4px;
    }
  }
`;
